import React, { FC } from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
} from '@material-ui/core';

import { SocialAccount } from 'api';
import { Numeric, SocialIcon, RefreshButton } from 'components';
import { getSocialAccountName } from 'helpers';
import useStyles from './itemStyles';

interface IProps {
  account: SocialAccount;
}

const ReachItem: FC<IProps> = ({ account }) => {
  const classes = useStyles();

  function renderValue() {
    return (
      <Typography color="textSecondary">
        <Numeric value={account.reach} />
      </Typography>
    );
  }

  return (
    <ListItem disableGutters classes={{ secondaryAction: classes.secondaryAction }}>
      <ListItemIcon className={classes.listIcon}>
        <SocialIcon provider={account.provider} />
      </ListItemIcon>
      <ListItemText disableTypography className={classes.overflow}>
        <Typography display="inline" variant="body2">
          {getSocialAccountName(account)}
        </Typography>
      </ListItemText>
      <ListItemSecondaryAction>
        {account.expires_soon ? <RefreshButton account={account} /> : renderValue()}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default ReachItem;
